<template>
    <div class="overflow-auto">
      <table ref="myTable" class="table table-bordered position-relative" width="100%">
        <tr v-if="isLoading">
          <td colspan="7">
            <div class="dot-loading mt-3">
              <ul class="loader-circle">
                <li></li>
                <li></li>
                <li></li>
              </ul>
            </div>
          </td>
        </tr>
      </table>
    </div>
    
  </template>
  
  <script>
  import CreateAccount from '@/services/CreateAccount';
  import $ from 'jquery';
  import 'datatables.net';
  import 'datatables.net-bs4';
  import 'datatables.net-responsive';
  
  import "datatables.net-buttons/js/dataTables.buttons.js"
  import "datatables.net-buttons/js/buttons.colVis.js"
  import "datatables.net-buttons/js/buttons.flash.js"
  import "datatables.net-buttons/js/buttons.html5.js"
  import "datatables.net-buttons/js/buttons.print.js"
  
  const baseURL = (process.env.VUE_APP_ENVIRONMENT == "production")?
    "https://gep-api.cgtechnology.io":(process.env.VUE_APP_ENVIRONMENT == "development"?
      "https://gep-api.cgtechnology.io":"https://gep-api.cgtechnology.io");
  const token = localStorage.getItem('token');
  
  const STATUS = {
    0:"Draft",
    1:"Pending",
    2:"Approved",
    3:"Rejected"
  };

  const USER_TYPE = {
    2 : "China Enterprise",
    3 : "Hongkong Enterprise",
    5 : "International" 
  }
  
  export default {
    data() {
      return {
        publicPath: process.env.BASE_URL !== '/' ? process.env.BASE_URL : '',
        isLoading:false,
        dataTable: null
      };
    },
    methods: {
      handleViewSubAccount(event){
        const data = this.dataTable.row($(event.target).closest('tr,li')).data();
        
        this.$router.push({ 
          path: '/list-sub-account',
          query: { "account_id":data.id }
        });
      },
      handleSubAccount(event){
        var data = this.dataTable.row($(event.target).closest('tr,li')).data();
        this.$emit('sub-account',data);
      },
      checkError(err){
        const response = err.response;
        try{
          if(response.status == 401 && response.data.name == "Unauthorized"){
                localStorage.removeItem("token");
                localStorage.removeItem("member");
                localStorage.removeItem("isFirstTime");
                this.$router.push({ 
                  path: '/login', 
                });
              }
          else{
            if(localStorage.getItem("token")){
              var msg = (response.data)?response.data.message:err.message;
              this.$notify({
                type: 'warn',
                text: msg
              })
            }
          }
        }catch(e){
          console.log(err);
        }        
      }
    },
    mounted() {
      let self = this;
      this.$nextTick(() => {
        self.isLoading = true;
        this.dataTable = $(this.$refs.myTable).DataTable({
          dom: 'lBfrtip',
            buttons: ['copy', 'csv', 'print'],
          // responsive: true, // Enable the Responsive extension
          searching: true,
          language: {
            info: '_START_-_END_ of _TOTAL_',
            infoEmpty: this.$t('Showing 0 to 0 of 0 entries'),
            search: '<i class="fa fa-search"></i>',
            searchPlaceholder: this.$t("Search"),
            emptyTable:this.$t("No data available in table"),
            paginate: {
              next: '<i class="fas fa-chevron-right"></i>',
              previous: '<i class="fas fa-chevron-left"></i>',
            },
          },
          serverSide: true,
          paging: true,
          ajax: function(data, callback, settings) {
              let columns = [];
              data.columns.forEach(function(item,index){
                columns.push({"data":item.data});
              });
  
              CreateAccount.list({
                draw:data.draw,
                search:data.search,
                start:data.start,
                length:data.length,
                order:data.order,
                columns:columns
              }).then((response)=>{
              if (response.status == 200) {

                self.isLoading = false;
                const responseData = response.data;
                let data = responseData.data;
                
                data.forEach(function(item) {
                  console.log(item);
                  item.userType = USER_TYPE[item.userType];
                  item.txt_status = STATUS[item.status];
                  item.enName = item.information.enName?item.information.enName:'';
                  item.have_sub_account = item.sub_account && item.sub_account.id?true:false;
                });
  
                callback({
                  draw: responseData.draw,
                  recordsTotal: responseData.recordsTotal,
                  recordsFiltered: responseData.recordsFiltered,
                  data: data,
                });
              }
            })
            .catch((err) => {
              self.checkError(err);
            });
          },
          columns: [
            { data: "transNo", title: "Transaction Number"},
            { data: "userNo", title: "User Number"},
            { data: "userType", title: "User Type"},
            { data: "txt_status", title: "Status"},
            { data: "created_at", title: "Created At"},
            { 
              data: "status",
              title: "Action",
              render: function(data, type, row) {
                console.log(row);
                let act = '';
                if(data == 2){
                  if(row.have_sub_account){
                    act = '<button class="btn btn-orange view-sub-account">View Sub Account</button>';
                  }
                  else{
                    act = '<button class="btn btn-orange create-sub-account">Create Sub Account</button>';
                  }
                }
                return act;
              }
            }
          ]
        });

        $(this.$refs.myTable).on('click', '.create-sub-account', this.handleSubAccount.bind(this));
        $(this.$refs.myTable).on('click', '.view-sub-account', this.handleViewSubAccount.bind(this));
      });
    },
    destroyed() {
      if (this.dataTable !== null) {
        this.dataTable.destroy(true);
      }
    },
  };
  </script>
  
<style>
.dataTables_length{
  float: left;
}
</style>